import { Injectable } from '@angular/core';
import { httpOptions } from '../../configurations/configuration';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class FlagConfigurationService {

  constructor(private http: HttpClient) { }

  updateProductConfiguration(postObj: any): Observable<any> {
    return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertFlagUrl, postObj, httpOptions);
  }

  insertProductConfiguration(postObj: any): Observable<any> {
    return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertFlagUrl, postObj, httpOptions);
  }

  getProductConfiguration(): Observable<any> {
    return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getFlagUrl);
  }

}
